import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/resources")({
  staticData: {
    title: "edge.navigation.resources",
  },
});
